import { render } from "./SketchUpload.vue?vue&type=template&id=1ca07adb&scoped=true"
import script from "./SketchUpload.vue?vue&type=script&lang=js"
export * from "./SketchUpload.vue?vue&type=script&lang=js"

import "./SketchUpload.vue?vue&type=style&index=0&id=1ca07adb&scoped=true&lang=css"

import exportComponent from "/Users/nogglema/Documents/Ecampus/css-205-lab-2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca07adb"]])

export default __exports__